import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { PublicLayout } from "../features/marketing/PublicLayout";
import { LegalPage } from "../features/marketing/legal/LegalPage";
import { SUBPROCESSORS } from "../features/marketing/legal/subprocessors";

export const Route = createFileRoute("/subprocessors")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: SubprocessorsPage,
});

function SubprocessorsPage() {
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <LegalPage documents={SUBPROCESSORS} />
    </PublicLayout>
  );
}
